<template>
    <div :style="color('bgcolor', 'background')" class="pb-48">



        <div v-if="upselling" class="fixed z-50 inset-0 overflow-y-auto">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <!--
                  Background overlay, show/hide based on modal state.
            
                  Entering: "ease-out duration-300"
                    From: "opacity-0"
                    To: "opacity-100"
                  Leaving: "ease-in duration-200"
                    From: "opacity-100"
                    To: "opacity-0"
                -->
                <div class="fixed inset-0 transition-opacity" aria-hidden="true">
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                <!--
                  Modal panel, show/hide based on modal state.
            
                  Entering: "ease-out duration-300"
                    From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    To: "opacity-100 translate-y-0 sm:scale-100"
                  Leaving: "ease-in duration-200"
                    From: "opacity-100 translate-y-0 sm:scale-100"
                    To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                -->
                <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                    <div>
                        <div class="mt-3 text-center sm:mt-5">
                            <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                                {{_("Want unlimited free delivery?")}}
                            </h3>
                            <div class="mt-2">
                                <p class="text-sm text-gray-700">
                                    
                                    {{ _("Great news! Get it now for an extra") }}
                                    <strong>${{ upsell_fee.toFixed(2) }}</strong>
                                    {{ _("only.") }}
                                </p>
                                <div class="text-sm text-gray-700 my-2">
                                    {{_("Valid for the following address")}}<sup>*</sup>: 
                                    <div class="bg-gray-100 px-2 py-1 text-xs text-left mt-1">{{ customer.address }}</div>
                                </div>
                                <div class="text-sm text-gray-700">
                                    {{_("Until")}} <strong>{{ next_month }}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                        <button @click="optin" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:col-start-2 sm:text-sm">
                            {{_("ADD TO CART")}}
                        </button>
                        <button @click="optout" type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm">
                            {{_("NO THANKS")}}
                        </button>
                    </div>

                    <div class="mt-4 text-xs text-gray-500"><sup>*</sup>{{_("Only valid while using your account")}} <PhoneFormatter :phone="customer.phone"></PhoneFormatter> 
                    {{_("while ordering to the qualifying address mentioned above")}}</div>
                </div>
            </div>
        </div>
        
        
        


        <div v-if="notification" class="z-50 fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end">
            <!--
              Notification panel, show/hide based on alert state.
          
              Entering: "transform ease-out duration-300 transition"
                From: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                To: "translate-y-0 opacity-100 sm:translate-x-0"
              Leaving: "transition ease-in duration-100"
                From: "opacity-100"
                To: "opacity-0"
            -->
            <div class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-10 overflow-hidden">
                <div class="p-4">
                    <div class="flex items-start">
                        <div class="flex-shrink-0">
                            <!-- Heroicon name: check-circle -->
                            <svg class="h-6 w-6 text-green-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <div class="ml-3 w-0 flex-1 pt-0.5">
                            <p class="text-sm font-medium text-gray-900">
                                {{notification}}
                            </p>
                        </div>
                        <div class="ml-4 flex-shrink-0 flex">
                            <button @click="notification=null" class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                <span class="sr-only">Close</span>
                                <!-- Heroicon name: x -->
                                <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                    <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        
        
        
        <div v-if="addresschange" class="p-8 bg-gray-200">
            
            <AddressChange 
                @alert="notification=$event"
                :subtotal="sub_total_without_fees"
                :restaurant="restaurant" :app_locale="app_locale" v-model="customer" 
                @refresh="$inertia.reload({only:['restaurant', 'flash']})"
                @close="closeaddress"></AddressChange>
            
        </div>
        <template v-else>


        <div v-if="showcheckout" class="fixed inset-0 overflow-hidden z-40">
            <div class="absolute inset-0 overflow-hidden">
                <section class="absolute inset-y-0 right-0 pl-10 max-w-full flex bg-gray-500 bg-opacity-75" aria-labelledby="slide-over-heading">
                    <!--
                      Slide-over panel, show/hide based on slide-over state.
              
                      Entering: "transform transition ease-in-out duration-500 sm:duration-700"
                        From: "translate-x-full"
                        To: "translate-x-0"
                      Leaving: "transform transition ease-in-out duration-500 sm:duration-700"
                        From: "translate-x-0"
                        To: "translate-x-full"
                    -->
                    <div class="w-screen max-w-md">
                        <div class="h-full flex flex-col py-6 bg-white shadow-xl overflow-y-scroll">
                            <div class="px-4 sm:px-6">
                                <div class="flex items-start justify-between">
                                    <h2 class="text-lg font-medium text-gray-900">
                                        {{ _("Your Order Details") }}
                                    </h2>
                                    <div class="ml-3 h-7 flex items-center">
                                        <button @click="showcheckout=false,$page.props.flash.error = ''" class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                            
                                            <IconXOutline></IconXOutline>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-6 relative flex-1 px-4 sm:px-6">
                                <div class="absolute inset-0 px-4 sm:px-6">

                                    <div class="w-full flex items-center mb-1 border-b border-gray-400 pb-1">
                                        <div class="flex-1 text-gray-600 font-medium text-sm">{{ _("Total") }}</div>
                                        <div class="font-medium text-lg">${{ (total - credits).toFixed(2) }}</div></div>
                                    <div class="w-full flex items-center mb-1 border-b border-gray-400 pb-1">
                                        <div class="flex-1 text-gray-600 font-medium text-sm">
                                            {{ _("Payment Method") }}
                                        </div>
                                        <div class="flex items-center gap-x-2">

                                            <svg v-if="method==='cash'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z" />
                                            </svg>

                                            <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />
                                            </svg>

                                            
                                            
                                            <div @click="method=method==='card'?'cash':'card'" class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                            <IconPencilOutline size="3" class="mr-2"></IconPencilOutline> {{ _("(edit)") }}
                                            </div>
                                        </div></div>
                                    <div class="w-full flex items-center mb-1 border-b border-gray-400 pb-1"><div class="flex-1 text-gray-600 font-medium text-sm">
                                        {{ _("Phone") }}
                                    </div>
                                        <div><PhoneFormatter :phone="customer.phone"></PhoneFormatter>
                                            
                                        </div></div>
                                    <div class="w-full flex items-center mb-1 text-gray-600 font-medium text-sm">
                                        {{ _("Delivery Address") }}
                                    </div>

                                    <div class="w-full mb-1">
                                        <div class="text-sm font-medium">
                                            {{ customer.address_string }}
                                        </div>
                                     
                                        <div class="text-right">
                                            <div @click="changeaddress" class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                            <IconPencilOutline size="3" class="mr-2"></IconPencilOutline>  {{ _("(edit)") }}
                                            </div>
                                        </div>
                                         
                                    
                                    </div>


                                    <div class="w-full flex items-center my-4 text-xs text-gray-900">* {{ _("If you changed your phone number, please uninstall the app and reinstall it using your new phone number.") }} </div>

                                    
                                    <div v-if="$page.props.flash && $page.props.flash.error" class="w-full flex items-center my-4 text-lg text-red-500 font-bold">
                                    {{ $page.props.flash.error }}
                                    </div>

                                    <div class="w-full">
                                        <div v-if="checkingout" class="bg-indigo-600 mx-4 rounded-lg px-6 py-4 uppercase font-medium text-white text-center">
                                            {{ _("Place Order") }} <IconDotsHorizontalOutline size="5"></IconDotsHorizontalOutline>
                                        </div>
                                        <div v-else @click="checkout" class="bg-indigo-600 mx-4 rounded-lg px-6 py-4 uppercase font-medium text-white text-center">
                                        {{ _("Place Order") }}
                                        </div>
                                    </div>

                                    <div class="w-full text-center my-4 ">{{ _("Or") }}</div>

                                    <div class="w-full">
                                        <div @click="showcheckout=false,showcart=true" class="bg-gray-300 mx-4 rounded-lg px-6 py-4 uppercase font-medium text-gray-900 text-center">
                                        {{ _("Edit your cart") }}
                                        </div>
                                    </div>

                                </div>
                                <!-- /End replace -->
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
        
        
        
        
        
        <div v-if="showsections" class="fixed inset-0 overflow-hidden z-50">
            <div class="absolute inset-0 overflow-hidden">
                <section class="absolute inset-y-0 right-0 pl-10 max-w-full flex" aria-labelledby="slide-over-heading">
                    <!--
                      Slide-over panel, show/hide based on slide-over state.
              
                      Entering: "transform transition ease-in-out duration-500 sm:duration-700"
                        From: "translate-x-full"
                        To: "translate-x-0"
                      Leaving: "transform transition ease-in-out duration-500 sm:duration-700"
                        From: "translate-x-0"
                        To: "translate-x-full"
                    -->
                    <div class="w-screen max-w-md">
                        <div class="h-full flex flex-col py-6 bg-white shadow-xl overflow-y-scroll">
                            <div class="px-4 sm:px-6">
                                <div class="flex items-start justify-between">
                                    <h2 id="slide-over-heading" class="text-lg font-medium text-gray-900">
<!--                                        Section-->
                                    </h2>
                                    <div class="ml-3 h-7 flex items-center">
                                        <button @click="showsections=false" class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                            <span class="sr-only">Close panel</span>
                                            <IconXOutline></IconXOutline>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-6 relative flex-1 px-4 sm:px-6">
                                <!-- Replace with your content -->
                                <div class="absolute inset-0 px-4 sm:px-6">

                                    <div @click="goto(category)" v-for="category in restaurant.categories" class="w-full my-2 py-2 border-b border-gray-200 cursor-pointer">
                                        {{ category.name }}
                                    </div>
                                    
                                </div>
                                <!-- /End replace -->
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>

        <transition
            enter-active-class="transform transition ease-in-out duration-100"
            enter-class="translate-x-full"
            enter-to-class="translate-x-0"
            leave-active-class="in-out duration-300"
            leave-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <Cart @order="order" v-if="showcart" v-model="cart" 
                  :minimum="restaurant.minimum" 
                  :discount="discount"
                  :credits="credits"
                  :upsell_fee="upsold?upsell_fee:0"
                  :app_locale="app_locale"
                  @optout="changeoptin"
                  :tps="tps" :tvq="tvq" :subtotal="subtotal" :total="total"
                  :fees="restaurant.fees" @close="closecart" @edit="editcart"></Cart>
        </transition>
        
            <transition
                enter-active-class="transform transition ease-in-out duration-100"
                enter-class="translate-x-full"
                enter-to-class="translate-x-0"
                leave-active-class="transform transition ease-in-out duration-100"
                leave-class="translate-x-0"
                leave-to-class="translate-x-full"
            >
            <ItemSelector
                v-if="current_item"
                    :item_id="current_item.id"
                :app_locale="app_locale"
                    :original="current_item"
                    :item="current_item.data"
                    :ingredients="restaurant.ingredients"
                    :submission="submission"
                    :submission_id="submission_id"
                :is_open="restaurant.is_open"
                :comments_disabled="restaurant.comments_disabled"
                    :live="true"
                    @submit="submit"
                    @cancel="cancel"
            ></ItemSelector>
            </transition>

        <template v-if="current_item">
        </template>
        <template v-else-if="showcart">
            
        </template>
       

        <template v-else>

            <div class="fixed bottom-0 right-0 mr-2 mb-2 z-30" >

                <div class="mb-4 p-4 bg-white text-center rounded shadow-lg " @click="showsections=true">
                    <IconViewListOutline class="w-8 h-8 text-black"></IconViewListOutline>
                </div>


                <div v-if="restaurant.is_open" class="p-4 bg-white text-center rounded shadow-lg " @click="opencart">
                    <div class="absolute bg-green-500 rounded-full text-xs w-6 h-6 text-center text-white items-center justify-center flex right-0 -mt-2 mr-2" v-if="cart.length > 0">{{ cart.reduce((c, i) => c + i.data.qty, 0) }}</div>

                    <IconShoppingCartOutline class="w-8 h-8 text-black"></IconShoppingCartOutline>
                    
                </div>

                
            </div>
            
            


            <div v-if="fixedheader" class="fixed z-30 top-0 left-0 right-0 bg-red-500 text-3xl text-white py-4 text-center">
                {{ fixedheader }}
            </div>

        <div class="bg-red-500 py-1 text-center text-white ">
            <div class="uppercase text-lg font-bold">{{ restaurant.name }}</div>
            <div class="uppercase text-lg font-bold">{{ restaurant.territory }}</div>
            <div class="font-normal text-sm">{{ restaurant.min }}</div>
        </div>

        <div v-if="restaurant.is_open" class="bg-green-500 text-center text-white">
            {{ restaurant.timestring }}
        </div>
        <div v-else class="bg-red-500 text-center text-white">
            {{ restaurant.timestring }}
        </div>



<!--            <div v-if="customer.status===1" class="bg-green-500 text-center text-white py-4">-->
<!--                {{  _("You qualify for a 10% discount") }}-->
<!--            </div>-->
            

            <div v-if="restaurant.message" :class="restaurant.delayed?'bg-red-500':'bg-green-500'" class="text-center text-white py-4">
                {{ restaurant.message }}
            </div>
            


        <div v-if="restaurant.sameprice" class="bg-yellow-400 text-center text-white">
            Même prix que le resto!
        </div>

        <div v-if="restaurant.image" class="w-full">
            <img :src="cdn + restaurant.image" class="max-w-full inline-block mx-auto" />
        </div>


        <div>

            <div v-for="category in restaurant.categories" class="wrap_menu" :ref="`category${category.id}`">
                <div class="title text-center " :style="color('color', 'color')">{{ category.name }}</div>


                <div class="w-full flex items-center" v-if="restaurant.props.icon">
                    <div class="w-1/4"></div>
                    <div class="h-2 border-b border-gray-600 flex-1"></div>
                    <div class="mx-2" :style="color('color', 'color')">
                        
                    </div>
                    <div class="h-2 border-b border-gray-600 flex-1"></div>
                    <div class="w-1/4"></div>
                </div>
                
                <div v-if="category.description" class="description text-center text-sm">{{ category.description }}</div>
                <div v-if="category.image" class="description">
                    <img :src="category.image" />
                </div>
                

                <div>

                    <div v-for="item in category.items" :id="`item_${item.id}`" class="mb-4 hover-item"
                         
                         :class="limited(item)?'opacity-50':''"
                         
                         @click="select(item)" :style="styleObject">

                        <div class="flex items-end justify-between mx-4 border-b-2 border-dotted border-gray-600 pb-1 mb-1">
                            <div class="item_namezzzzz text-lg flex-1 mr-2 font-bold" :style="color('color', 'color')">{{ item.label || item.name }}</div>
                            
                            <div v-if="outofstock(item)" class="text-right font-medium text-red-700">
                                {{ _("Unavailable")}}
                            </div>
                            <div v-else class="item_pricezzz text-right font-medium" :style="color('pricecolor', 'color')">
                                {{ item.price }}
                                
                            </div>
                        </div>
                        <div class="item_description px-4">{{ item.description }}</div>

                    </div>


                </div>


            </div>

        </div>
        </template>
            
        </template>

    </div>
</template>

<script>
    import debounce from 'debounce';
    import ItemSelector from "../ItemSelector";
    import Cart from "./Cart";
    import Vue from 'vue';
    import IconXOutline from "../../../icons/outline/IconXOutline";
    import IconViewListOutline from "../../../icons/outline/IconViewListOutline";
    import IconShoppingCartOutline from "../../../icons/outline/IconShoppingCartOutline";
    import Icon from "../../Shared/Icon";
    import {lang} from "../../lang";
    import PhoneFormatter from "../../Shared/PhoneFormatter";
    import IconPencilOutline from "../../../icons/outline/IconPencilOutline";
    import TextField from "../../Shared/TextField";
    import IconLocationMarkerSolid from "../../../icons/solid/IconLocationMarkerSolid";
    import AddressChange from "../../Shared/AddressChange";
    import IconQuestionMarkCircleOutline from "../../../icons/outline/IconQuestionMarkCircleOutline";
    import IconHandSolid from "../../../icons/solid/IconHandSolid";
    import moment from "moment";
    import IconDotsHorizontalOutline from "../../../icons/outline/IconDotsHorizontalOutline";
    
    export default {
        name: "Menu",
        props: ['customerprop', 'restaurant', 'app_locale', 'token', 'has_free_delivery', 'should_upsell', 'upsell_fee'],
        components: {
            IconDotsHorizontalOutline,
            IconHandSolid,
            IconQuestionMarkCircleOutline,
            AddressChange,
            IconLocationMarkerSolid,
            TextField,
            IconPencilOutline,
            PhoneFormatter,
            Icon,
            IconShoppingCartOutline,
            IconViewListOutline,
            IconXOutline,
            ItemSelector, Cart,
        },
        data() {
            return {
                customer: this.customerprop,
                cart: (this.$page.props.cart && this.$page.props.cart[this.restaurant.id]) ? this.$page.props.cart[this.restaurant.id].data : [],
                cdn: cdn,
                addresschange: false,
                showcheckout: false,
                showcart: false,
                showsections: false,
                current_item: null,
                scrollposition: 0,
                current_scroll: 0,
                fixedheader: null,
                cart_item: null,
                submission_id: null,
                method: 'cash',
                notification: null,

                upsold: false,
                upselling: false,

                checkingout: false,
            }
        },
        
        watch: {
            cart: {
                deep: true,
                handler() {
                    window.axios.post(this.$route("user.cart.update"), {id: this.restaurant.id, data: this.cart}).then(e => {
                        console.log("cart updated");
                    })
                }
            }
        },
        mounted() {
            console.log(this.should_upsell, this.has_free_delivery);
            console.log(this.cart);
            // window.axios.post("/api/menu/" + this.restaurant, {
            //     customer: this.customer, token: this.token,
            //     app_locale: this.app_locale})
            //     .then(response => {
            //         this.rest = response.data;
            //     });
        },


        created() {
            this.handleDebouncedScroll = debounce(this.handleScroll, 10);
            window.addEventListener('scroll', this.handleDebouncedScroll);
        },

        beforeDestroy() {
            // I switched the example from `destroyed` to `beforeDestroy`
            // to exercise your mind a bit. This lifecycle method works too.
            window.removeEventListener('scroll', this.handleDebouncedScroll);
        },

        computed: {
            
            sub_total_without_fees() {
              return this.items_subtotal - this.discount;
            },
            submission() {
                if (this.cart_item) {
                    return this.cart_item.data;
                }
                return null;
            },

            next_month() {
                const string = moment().locale(this.app_locale).add(1, "month").format("MMMM D, YYYY");  
                return string.substr(0, 1).toUpperCase() + string.substr(1);
            },
            
            items_subtotal() {
                return this.cart.map(item => item.price * item.data.qty).reduce((a, b) => (1 * a) + (1*b), 0);
            },
            
            taxable_subtotal() {
                const discount = this.restaurant.discount ? (1 - (this.restaurant.discount / 100)) : 1;
                return  (this.cart.filter(item => item.original.taxable).map(item => item.price * item.data.qty)
                    .reduce((a, b) => (1 * a) + (1*b), 0) * discount) + this.restaurant.fees + this.upsellprice;
            },

            tps() {
                return this.taxable_subtotal * 0.05;
            },
            
            upsellprice() {
                return this.upsold ? this.upsell_fee : 0;
            },

            tvq() {
                return this.taxable_subtotal * 0.09975;
            },
            subtotal() {
                return this.items_subtotal - this.discount + this.restaurant.fees + this.upsellprice;
            },

            total() {
                return this.subtotal + this.tps + this.tvq;
            },
            
            credits() {
                return Math.min(this.customer.current_credits, this.total);  
            },

            discount() {
                let disc = 0;
                // if (this.customer.status === 1) { // first.
                //     disc = 10;
                // }
                if (this.restaurant.discount > 0) {
                    disc = Math.max(disc, this.restaurant.discount);
                }
                return this.items_subtotal * disc / 100;
            },
            
            styleObject() {
                let color = "#7cfc00";
                if (this.restaurant && this.restaurant.props.rollover) {
                    color = this.restaurant.props.rollover;
                }
                return {
                    '--color-hover': color
                }
            }
            
        },

        methods: {
            
            crt() {
                this.cart_item = this.cart[0].data;
                this.select(this.cart[0].original);
            },
            
            submit(data) {
                console.log("submitting", this.submission_id, data);
                if (this.submission_id !== null) {
                    this.cart.splice(this.submission_id, 1, data);
                } else {
                    this.cart.push(data);
                }
                this.submission_id = null;
                this.cancel();
            },
            
            cancel() {
                this.current_item = null;
                this.cart_item = null;
                
                Vue.nextTick(() => {
                    this.restoreScroll();
                    setTimeout(() => {
                        this.restoreScroll();
                    }, 400);
                })
            },
            
            saveScroll() {
                this.scrollposition = window.document.documentElement.scrollTop || window.document.body.scrollTop;
            },
            setScroll(location, additive=false) {
                let loc = additive ? window.document.documentElement.scrollTop || window.document.body.scrollTop : 0;
                loc += location;
                window.scrollTo(0, loc);
                setTimeout(() => {
                    this.handleScroll(null);
                }, 200);
            },
            restoreScroll() {
                this.setScroll(this.scrollposition);
            },
            
            totalItemsOf(id) {
                return this.cart.filter(row => row.original.id === id).reduce((c, row) => c + row.data.qty, 0)
            },
            
            outofstock(item) {
                const out = 
                    item.active === false || 
                    item.quantity === 0 ||
                    (item.quantity - this.totalItemsOf(item.id)) <= 0 || 
                    (item.ingredients && item.ingredients.filter(ing => !ing.active).length > 0); // ingredients. 
                
                return out;
            },

            limited(item) {
                return item.limited && this.cart.map(item => item.original.id).filter(id => id === item.id).length > 0;  
            },
            
            select(item) {
                
                if (this.limited(item)) {
                    this.notification = this._("This item has a limit of one per cart");
                    return;
                }
                
                if (!this.restaurant.is_open || this.outofstock(item)) {
                    return;
                }
                this.saveScroll();
                this.current_item = item;
                this.setScroll(0);
            },
            handleScroll(event) {

                this.current_scroll = window.document.documentElement.scrollTop || window.document.body.scrollTop;
                let cats = this.restaurant.categories.filter(category => {
                    return this.$refs[`category${category.id}`] && this.$refs[`category${category.id}`].length > 0 &&  this.$refs[`category${category.id}`][0].offsetTop < this.current_scroll;
                });
                
                if (!this.restaurant.is_open && this.current_scroll > 100) {
                    this.fixedheader = this.restaurant.timestring;
                } else {
                    if (cats.length === 0) {
                        this.fixedheader = null;
                    } else {
                        this.fixedheader = cats[cats.length - 1].name;
                    }
                }


            },
            
            
            editcart({item, index}) {
                console.log(item, index);
                this.current_item=item.original;
                this.cart_item=item;
                this.submission_id = index
                this.showcart = false;
            },
            
            color(key, ref) {
                if (this.restaurant && this.restaurant.props[key]) {
                    return ref + ': ' + this.restaurant.props[key];
                }
                return '';
            },


            order(method) {

                this.method = method;
                if (!this.upsold && (this.should_upsell && !this.has_free_delivery)) {
                    this.upselling = true;
                    return;
                }

                this.showcart = false;
                this.showcheckout = true;
                
            },
            
            optin() {

                this.upsold = true;
                this.upselling = false;
                
                // this.showcart = false;
                // this.showcheckout = true;
            },
            
            changeoptin() {
                this.upsold = false;
            },
            
            optout() {
                this.showcart = false;
                this.showcheckout = true;
                this.upselling = false;
                this.upsold = false;
            },
            
            
            checkout() {
                if (this.checkingout || this.cart.length === 0) {
                    return;
                }
                this.checkingout = true;

                let android_version = '';
                try {
                    const ua = navigator.userAgent.toLowerCase();
                    const match = ua.match(/android\s([0-9\.]*)/i);
                    android_version = match ? parseFloat(match[1]) : 0;
                } catch(e) {
                    android_version = '-';
                }

                
                this.$inertia.post(this.$route('user.checkout', {
                    restaurant: this.restaurant.id,
                    app_locale: this.app_locale,
                    customer: this.customer.id
                }), {data:
                        this.cart.map(item => {
                            let data = JSON.parse(JSON.stringify(item.data));
                            data.id = item.original.id;
                            data.remarks = item.remarks;
                            data.price = 1 * item.price;
                            return data
                        }),
                    total: this.total,
                    upsold: this.upsold,
                    method: this.method,
                    android_version: android_version,
                }, {
                    onFinish: () => {
                        this.checkingout = false;
                    }
                });
            },

            goto(category) {
                this.showsections = false;
                const item = this.$refs[`category${category.id}`][0];
                item.scrollIntoView(true);
                Vue.nextTick(() => {
                    this.setScroll(10, true);
                })
            },

            opencart() {
                this.saveScroll();
                this.showcart = true;
                this.setScroll(0);
            },
            
            closecart() {
                this.showcart=false;
                // this.submission_id=null;
                Vue.nextTick(() => {
                    this.restoreScroll();
                });
            },
            
            closeaddress() {
                this.addresschange=false;
                this.showcheckout=true;
            },
            
            
            changeaddress() {

                this.$page.props.flash.error = '';
                this.saveScroll();
                this.addresschange=true;
                this.setScroll(0);
            },
            
            _(k) {
                return lang(k, this.app_locale === 'fr_CA' ? 'fr' : 'en')
            },

            upsell() {
                
            },

        }
    }
</script>

<style scoped>

    .wrap_menu {
        position: relative;
        margin: 0 auto;
        width: 100%;
        max-width: 980px;
        overflow: hidden;
        /*font-family: Lato, sans-serif;*/
    }

    .wrap_menu .title {
        position: relative;
        /*color: #333333;*/
        font-size: 50px;
        font-weight: 400;
        /*font-family: Lemon-Milk, sans-serif;*/
    }

    /*.wrap_menu .title:before {*/
    /*    content: '';*/
    /*    width: 50%;*/
    /*    left: 0;*/
    /*    right: 0;*/
    /*    border-bottom: 2px solid #ddd;*/
    /*    position: absolute;*/
    /*    bottom: -13px;*/
    /*    margin: 0 auto;*/
    /*}*/

    /*.wrap_menu .title:after {*/
    /*    content: "\f0f5";*/
    /*    font-family: 'FontAwesome';*/
    /*    font-size: 18px;*/
    /*    background: #fff;*/
    /*    position: absolute;*/
    /*    left: 50%;*/
    /*    bottom: -22px;*/
    /*    padding: 0 10px;*/
    /*    -webkit-transform: translateX(-50%);*/
    /*    -moz-transform: translateX(-50%);*/
    /*    -o-transform: translateX(-50%);*/
    /*    transform: translateX(-50%);*/
    /*}*/

    .wrap_menu .description {
        margin-top: 25px;
        margin-bottom: 25px;
        color: #7d7d7d;
        font-size: 15px;
    }

    .wrap_menu .description img {
        max-width: 100%;
        height: auto;
    }

    .wrap_menu .item {
        position: relative;
        margin-bottom: 20px;
        padding: 10px;
        box-sizing: border-box;
        transition: background-color .5s;
        -webkit-transition: background-color .5s;
        -moz-transition: background-color .5s;
        -ms-transition: background-color .5s;
        display: block;
        text-decoration: none;
    }

    .wrap_menu .item:hover {
        background-color: #7cfc00;
    }

    .hover-item:hover {
        background-color: var(--color-hover);
    }
    

    .item_name {
        position: relative;
        width: 100%;
        font-size: 18px;
        color: #333333;
        font-weight: bold;
        display: inline-block;
    }

    .item_name:after {
        display: inherit;
        content: '';
        background-image: radial-gradient(circle closest-side, #b3b3b3 99%,rgba(0,0,0,0) 1%);
        background-position: bottom;
        background-size: 6px 3px;
        background-repeat: repeat-x;
        -ms-border-bottom: dotted #b3b3b3;
        margin-left: 0px;
        height: 5px;
        width: 100%;
        position: absolute;
        bottom: 0;
    }

    .wrap_menu .item_description {
        margin: 0;
        margin-top: 3px;
        margin-bottom: 20px;
        color: #7d7d7d;
        font-size: 15px;
    }

    .wrap_menu .item_price {
        position: absolute;
        top: 5px;
        right: 10px;
        /*color: #F32A2A;*/
        font-size: 18px;
        font-family: Oswald, sans-serif;
    }

    .wrap_menu .text-center { text-align: center; }

    .menu_spacer {
        height: 200px; /* Empty space below the menu */
    }

    .wrap_menu_header {
        display: none;
    }

    .wrap_menu_fixed .wrap_menu_header {
        display: block;
        position: fixed;
        top: 0px;
        left: 0px;
        right: 0px;
        background: red;
        z-index: 2;
        font-size: 24px;
        padding: 5px;
        color: white;
        text-align: center;
    }

</style>
